(function () {
  'use strict';

  var ROOT_SELECTOR = '#MainContent, main';
  var EXCLUDED_SELECTOR = [
    '.site-header',
    '.product-nav',
    '[class*="product-nav"]',
    '[class*="purchase"]',
    '[class*="sticky"]',
    '[data-sticky]',
    '.custom-lp__container',
    'form',
    '[role="dialog"]'
  ].join(',');
  var CARD_SELECTOR = [
    'article',
    '.product-card',
    '.ranking-card',
    '.story-card',
    '.journal-card',
    '.model-card',
    '.scene-card',
    '.category-item',
    '.age-item',
    '.gift-feature',
    '.brand-message',
    '.why-card',
    '.consult-panel',
    '.pdp-ugc-card',
    '.pdp-review-card',
    '.pdp-color-card',
    '.detail-card',
    '.morby-detail-card',
    '.age-card',
    '.gift-card',
    '.news-card',
    '.colulu-news-index-v2__item',
    '.colulu-top-news-v2__item'
  ].join(',');
  var HEADING_SELECTOR = [
    '.section-heading',
    '.journal-header',
    '.more-products-header',
    '.top-news-v2__head',
    '.brand-lead__copy',
    '.scene-section > .section-heading',
    '.category-section > .section-heading',
    '.age-section > .section-heading',
    '.air-section-heading',
    '.pdp-section-heading',
    '.morby-section-heading',
    '.colulu-news-index-v2__head',
    '.colulu-top-news-v2__head'
  ].join(',');
  var MEDIA_SELECTOR = [
    'figure',
    '.media',
    '.product-card__image',
    '.story-card__media',
    '.journal-card__media',
    '.journal-card__image',
    '.model-card__media',
    '.scene-card__media',
    '.gift-feature__media',
    '.brand-message__media',
    '.wide-cta-section__media',
    '.consult-panel__media',
    '.detail-card__media',
    '.ranking-card__media'
  ].join(',');
  var PDP_ROOT_SELECTOR = [
    '[data-product-template="pdp-v2"]',
    '[data-colulu-v2-product]',
    '[data-product-root]',
    '.pdp-v2-page',
    '.hugwarmer-page',
    '.drimug-page'
  ].join(',');
  var PDP_MOTION_EXCLUDED_SELECTOR = [
    '[data-section-type="product-hero"]',
    '[data-product-buy-panel]',
    '[data-media-gallery]',
    '[data-details-scroller]',
    '[data-scene-scroller]',
    '[data-scene-track]',
    '[class*="thumb"]',
    '[class*="sticky"]',
    '[class*="purchase"]'
  ].join(',');
  var TOP_PARALLAX_SELECTOR = [
    '.scene-editorial-grid .scene-card--lead .scene-card__media',
    '.gift-feature__media',
    '.brand-message__media',
    '.wide-cta-section__media'
  ].join(',');
  var parallaxItems = [];
  var parallaxVisible = new Set();
  var parallaxObserver = null;
  var parallaxTicking = false;
  var parallaxListening = false;

  function isExcluded(element) {
    return Boolean(element.closest(EXCLUDED_SELECTOR) || element.querySelector(EXCLUDED_SELECTOR));
  }

  function isHero(element, root) {
    var firstSection = root.querySelector('section');
    return element === firstSection || Boolean(
      element.closest('[class*="hero"], [id*="Hero"], [id*="hero"]') ||
      element.querySelector('[class*="hero"], [id*="Hero"], [id*="hero"]')
    );
  }

  function getSections(root) {
    var shopifySections = Array.prototype.slice.call(root.children).filter(function (element) {
      return element.classList && element.classList.contains('shopify-section');
    });
    var candidates = shopifySections.length
      ? shopifySections
      : Array.prototype.slice.call(root.querySelectorAll('section'));

    return candidates.filter(function (element) {
      if (isExcluded(element)) return false;
      return !element.parentElement || !element.parentElement.closest('section');
    });
  }

  function hasPdp(root) {
    return Boolean((root.matches && root.matches(PDP_ROOT_SELECTOR)) || root.querySelector(PDP_ROOT_SELECTOR));
  }

  function isPdpMotionExcluded(element) {
    return Boolean(element.closest(PDP_MOTION_EXCLUDED_SELECTOR) || element.querySelector(PDP_MOTION_EXCLUDED_SELECTOR));
  }

  function decoratePdp(root) {
    if (!hasPdp(root)) return;

    root.querySelectorAll('section').forEach(function (section, sectionIndex) {
      if (isExcluded(section) || isPdpMotionExcluded(section) || isHero(section, root)) return;

      var heading = section.querySelector(':scope > header, :scope > [class*="__head"], :scope > div > header, :scope > h2');
      if (heading && !isExcluded(heading)) {
        heading.setAttribute('data-colulu-motion', 'pdp-copy');
        heading.style.setProperty('--colulu-motion-delay', String(Math.min(sectionIndex % 3, 2) * 55) + 'ms');
      }

      var media = Array.prototype.find.call(section.querySelectorAll('figure'), function (figure) {
        if (!figure.querySelector('img') || isExcluded(figure) || isPdpMotionExcluded(figure)) return false;
        var rect = figure.getBoundingClientRect();
        return rect.width >= 300 && rect.height >= 260;
      });
      if (media) {
        media.setAttribute('data-colulu-motion', 'pdp-media');
        media.setAttribute('data-colulu-motion-media', '');
        media.style.setProperty('--colulu-motion-delay', '140ms');
      }
    });
  }

  function updateParallax() {
    parallaxTicking = false;
    if (!parallaxVisible.size) return;

    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var distance = mobile ? 9 : 18;
    parallaxVisible.forEach(function (element) {
      var rect = element.getBoundingClientRect();
      var denominator = viewportHeight * 0.5 + rect.height * 0.5;
      var progress = denominator ? (viewportHeight * 0.5 - (rect.top + rect.height * 0.5)) / denominator : 0;
      progress = Math.max(-1, Math.min(1, progress));
      element.style.setProperty('--colulu-parallax-y', (progress * distance).toFixed(2) + 'px');
      element.style.setProperty('--colulu-parallax-scale', mobile ? '1.05' : '1.065');
    });
  }

  function requestParallaxUpdate() {
    if (parallaxTicking) return;
    parallaxTicking = true;
    window.requestAnimationFrame(updateParallax);
  }

  function registerParallax(element) {
    if (!element || element.hasAttribute('data-colulu-parallax') || !element.querySelector('img')) return;
    element.setAttribute('data-colulu-parallax', '');
    parallaxItems.push(element);

    if (parallaxObserver) {
      parallaxObserver.observe(element);
    } else {
      parallaxVisible.add(element);
    }
  }

  function initializeParallax(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    root.querySelectorAll(TOP_PARALLAX_SELECTOR).forEach(registerParallax);
    if (hasPdp(root)) {
      root.querySelectorAll('[data-colulu-motion="pdp-media"]').forEach(function (media) {
        var rect = media.getBoundingClientRect();
        if (rect.width >= 300 && rect.height >= 380) registerParallax(media);
      });
    }

    if (!parallaxListening) {
      parallaxListening = true;
      if ('IntersectionObserver' in window) {
        parallaxObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              parallaxVisible.add(entry.target);
            } else {
              parallaxVisible.delete(entry.target);
            }
          });
          requestParallaxUpdate();
        }, { rootMargin: '20% 0px 20% 0px' });
        parallaxItems.forEach(function (element) { parallaxObserver.observe(element); });
      }
      window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
      window.addEventListener('resize', requestParallaxUpdate, { passive: true });
    }
    requestParallaxUpdate();
  }

  function decorate(root) {
    var sections = getSections(root);

    sections.forEach(function (section) {
      if (section.getAttribute('data-colulu-motion') === 'section') {
        section.removeAttribute('data-colulu-motion');
        section.style.removeProperty('--colulu-motion-delay');
      }
    });

    root.querySelectorAll(HEADING_SELECTOR).forEach(function (heading, index) {
      if (isExcluded(heading) || isHero(heading, root)) return;
      heading.setAttribute('data-colulu-motion', 'heading');
      heading.style.setProperty('--colulu-motion-delay', String(Math.min(index % 3, 2) * 65) + 'ms');
    });

    root.querySelectorAll(CARD_SELECTOR).forEach(function (card, index) {
      if (isExcluded(card) || isHero(card, root)) return;
      card.classList.add('colulu-motion-card');
      card.setAttribute('data-colulu-motion', 'card');
      card.style.setProperty('--colulu-motion-delay', String(Math.min(index % 4, 3) * 85) + 'ms');
    });

    root.querySelectorAll(MEDIA_SELECTOR).forEach(function (media) {
      if (isExcluded(media) || isHero(media, root) || !media.querySelector('img')) return;
      media.setAttribute('data-colulu-motion-media', '');
      if (!media.closest('[data-colulu-motion]')) {
        media.setAttribute('data-colulu-motion', 'media');
      }
    });

    sections.forEach(function (section, index) {
      if (isHero(section, root) || section.querySelector('[data-colulu-motion]')) return;
      section.setAttribute('data-colulu-motion', 'section');
      section.style.setProperty('--colulu-motion-delay', String(Math.min(index % 3, 2) * 55) + 'ms');
    });

    return Array.prototype.slice.call(root.querySelectorAll('[data-colulu-motion]'));
  }

  function revealAll(elements) {
    elements.forEach(function (element) {
      element.classList.add('is-colulu-motion-visible');
    });
  }

  function initialize(root) {
    root = root || document;
    var main = root.matches && root.matches(ROOT_SELECTOR)
      ? root
      : root.querySelector(ROOT_SELECTOR) || (root.closest && root.closest(ROOT_SELECTOR));
    if (!main) return;

    decorate(main);
    decoratePdp(main);
    initializeParallax(main);
    var elements = Array.prototype.slice.call(main.querySelectorAll('[data-colulu-motion]'));
    if (!elements.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      revealAll(elements);
      return;
    }

    document.body.classList.add('colulu-motion-ready');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-colulu-motion-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.06,
      rootMargin: '0px 0px -5% 0px'
    });

    elements.forEach(function (element) {
      observer.observe(element);
    });

    window.setTimeout(function () {
      elements.forEach(function (element) {
        var rect = element.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight * 1.15) {
          element.classList.add('is-colulu-motion-visible');
          observer.unobserve(element);
        }
      });
    }, 1800);
  }

  function boot() {
    window.requestAnimationFrame(function () {
      initialize(document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      revealAll(Array.prototype.slice.call(document.querySelectorAll('[data-colulu-motion]')));
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
}());
